<script>
import {
  requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
    name: 'DeleteModal',
    props:[
      "routerList",
      "deleteIds"
    ],
    data() {
        return {
              form: {
                type: ''
              },
              submitted: false,
              blok: true,
            };
    },
    validations: {
      form: {    
        router_id: {
          required: requiredIf(function () {
            return this.form.type == 'l' && this.deleteIds.length == 0
          })
        },
        ip: {
          required: requiredIf(function () {
            return this.deleteIds.length == 0
          })
        },
        type: {
          required: requiredIf(function () {
            return this.deleteIds.length == 0
          })
        },
        subnet: {
          required: requiredIf(function () {
            return this.deleteIds.length == 0
          })
        },
      },
    },
    methods: {
        async destroy(subscription_delete = null){
          this.submitted = true;
          this.$v.form.$touch();
          if (this.$v.$invalid) return;
          await this.$http.post('/ips/delete', { ...this.form, delete_ids:this.deleteIds, subscription_delete })
                .then(resp => {
                    if(resp.data.code !==  100)  return notify.error(resp.data.message)
                  
                    notify.success(resp.data.message)
                    this.$emit('loadItems');
                })
          this.submitted = false;
          this.close()
        },
        close(){
          this.$parent.$bvModal.hide('delete-ip')
        }
    },
};
</script> 

<template>
  <b-modal id="delete-ip" title="İp Sil"  no-close-on-backdrop hide-footer>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12" v-if="deleteIds.length == 0">
          <div class="mb-3">
            <label>İp Tipi Seçiniz</label>
            <select v-model="form.type" class="form-select" :class="{
                    'is-invalid': submitted && $v.form.type.$error,
                  }">
                    <option value=''>Seçiniz</option>
                    <option value="s">Statik İp</option>
                    <option value="l">Lokal İp</option>
            </select>
            <div
              v-if="submitted && !$v.form.type.required"
              class="invalid-feedback"
            >
              Bu alanı doldurmak zorunludur.
            </div>
          </div>
        </div>
        <div class="col-12" v-if="form.type == 'l' && deleteIds.length == 0">
          <div class="mb-3">
            <label for="name">Mikrotik Seçiniz</label>
            <v-select 
              v-model="form.router_id"
              :filterable="false"
              :options="routerList"
              label="nasname"
              :reduce="r => r.id">
                <template slot="no-options">
                  Router ismi veya ip ile arayın
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.nasname }} - {{ option.shortname }}
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.nasname }} - {{ option.shortname }}
                  </div>
                </template>
            <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
            <div
              v-if="submitted && !$v.form.router_id.required"
              class="invalid-feedback"
            >
              Bu alanı doldurmak zorunludur.
            </div>
          </div>
        </div>
        <div class="col-12" v-if="deleteIds.length == 0">
          <div class="row mb-3">
            <div class="col-md-6">
                <label for="ip">İp</label>
                <input
                  id="ip"
                  v-model="form.ip"
                  type="text"
                  class="form-control"
                  placeholder="İp"
                  :class="{
                    'is-invalid': submitted && $v.form.ip.$error,
                  }"
                />
                <div
                  v-if="(submitted && !$v.form.ip.required) || !$v.form.type.required"
                  class="invalid-feedback"
                >
                    Bu alanı doldurmak zorunludur.
                </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <ul class="nav nav-tabs nav-justified">
                  <li class="nav-item" @click.prevent="blok=true">
                    <a class="nav-link" :class="{ active:blok === true }"   style="padding:3px" href="#">Blok Gir</a>
                  </li>
                  <li class="nav-item" @click.prevent="blok=false" >
                    <a class="nav-link" :class="{ active:blok === false  }" style="padding:3px" href="#">Aralık Gir</a>
                  </li>
                </ul>
                <div class="input-group mb-3">
                  <div class="input-group-append">
                    <span class="input-group-text" v-if="blok === true">/</span>
                    <span class="input-group-text" v-else>-</span>
                  </div>
                  <input
                  id="subnet"
                  v-model="form.subnet"
                  type="text"
                  class="form-control"
                  placeholder="24"
                  :class="{
                    'is-invalid': submitted && $v.form.subnet.$error,
                  }"
                />
                </div>
                <div
                  v-if="submitted && !$v.form.subnet.required"
                  class="invalid-feedback"
                >
                Bu alanı doldurmak zorunludur.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="deleteIds.length == 0">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" v-model="form.mikrotik_delete" value="1" id="flexCheckDefault">
            <label class="form-check-label" for="flexCheckDefault">
              Mikrotiktede Aynı İşlemi Yap
            </label>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <b-button 
          type="submit" 
          block
          variant="danger" 
          class="ms-1"
          @click="destroy()"
          >
          <span v-if="deleteIds.length > 0">Seçili İpleri Sil</span>
          <span v-else>Aralıktaki Tüm İpleri Sil</span>
        </b-button> 
      </div>
      <div class="d-flex justify-content-between mt-3"> 
        <b-button 
          type="submit" 
          block
          variant="danger" 
          @click="destroy(1)"
          class="ms-1"
          >
          <span v-if="deleteIds.length > 0">İpdeki Müşterileri Boşa Çıkar</span>
          <span v-else>Aralıktaki Tüm Müşterileri Boşa Çıkar</span>
        </b-button>
        <b-button variant="light" @click="close()">Vazgeç</b-button>
      </div>
    </form>
  </b-modal>
</template>